import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useDispatch, useSelector} from "react-redux";
import {changeContract} from "../contractSlice";


export default function ResidualsTabs(props) {
    const [contractTabValue, setContractTabValue] = React.useState(0);

    const selectorTabIndex = useSelector((state) => state.contractSlc.value.residualsTabsIndex);

    const dispatchData = useDispatch();

    const handleChange = (event, newValue) => {
        setContractTabValue(newValue);
        console.log("tab index = ",newValue);
        if (newValue == 0) {
            dispatchData(changeContract({residualsTabsIndex: 0,contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false
                , residualsTabsVisible: true, module: 'Residuals',workTabsVisible: false,contractGridAPI: "CBA"}));
        }
        if (newValue == 1) {
            dispatchData(changeContract({residualsTabsIndex: 1, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                 residualsTabsVisible: true, module: 'Residuals',workTabsVisible: false,contractGridAPI: "Sideletter"}));
        }
    if (newValue == 2) {
        dispatchData(changeContract({residualsTabsIndex: 2, contractGridVisible: true,
            contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false
            , residualsTabsVisible: true, module: 'Residuals',workTabsVisible: false,contractGridAPI: "SideletterTemplate"}));
    }
        if (newValue == 3) {
            dispatchData(changeContract({residualsTabsIndex: 3,contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false
                , residualsTabsVisible: true, module: 'Residuals',workTabsVisible: false,contractGridAPI: "DeterminationLetter"}));
        }
    if (newValue == 4) {
        dispatchData(changeContract({residualsTabsIndex: 4, contractGridVisible: true,
            contractDrilldownVisible: false, contractConfigVisible: true, contractSearchVisible: false,
            residualsTabsVisible: false, module: 'Residuals',workTabsVisible: false,contractGridAPI: "ResPre"}));
    };
}

    return (

        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={selectorTabIndex} defaultValue={selectorTabIndex}
                  onChange={handleChange} centered
                  // sx={{
                  //     '& .MuiTabs-flexContainer': {
                  //         gap: 3, // 24px between tabs
                  //     },
                  // }}
                  // sx={{
                  //     '& .MuiTab-root': {
                  //         px: 3, // 32px padding on each side
                  //     },
                  // }}
            >
                <Tab label="Collective Bargaining Agreements"
                     title="Union contracts to which individual contracts are subject"
                     sx={{
                         mx: 4,
                         minWidth: 350,
                         maxWidth: 'none',
                         whiteSpace: 'nowrap',
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Sideletter Agreements"
                     title="Product-specific contracts to which individual contracts are subject"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Sideletter Templates"
                     title="Standard templates for sideletter agreements"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Determination Letters"
                     title="Policy letters describing how contracts should be administered"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Configurations"
                     title="Configurations and methods added by the system to contract models during build"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />

            </Tabs>
        </Box>

    );
}
